import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row} from "react-bootstrap";
import { BiCalendar, BiXCircle } from "react-icons/bi";
import DateTimePicker from 'react-datetime-picker';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { isNaturalNumber } from '../utils/jsUtils';


const JobAdmin_NewJobView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [jobAttrs, setJobAttrs] = useState({
    name: '',
    description: '',
    service: '',
    recurrence: '',
    frequency: '',
    stateSetting: '',
    status: 'JOB_ST_STOPPED',  // When a job is created, the initial status is always STOPPED.
    startTime: '',
    endTime: ''
  });


  const serviceOptions = [
    { key: "DATA_COLLECTOR",  value: "Data collector" },
    { key: "DATA_DISPATCHER", value: "Data dispatcher" }
  ];

  const recurrenceOptions = [
    { key: "ONCE",      value: "ONCE" },
    { key: "RECURRING", value: "RECURRING" }
  ];

  const stateOptions = [
    { key: "JOB_STSET_ACTIVE",    value: "JOB_STSET_ACTIVE" },
    { key: "JOB_STSET_SUSPENDED", value: "JOB_STSET_SUSPENDED" }
  ];


  // Initialize state
  useEffect(() => {
  }, [props]);


  // UI Functions

  const [errMsg, setErrMsg] = useState('');


  const onAttrsInputChange = (e) => {
    setJobAttrs({ ...jobAttrs, [e.target.name]: e.target.value })
  }

  const onServiceSelect = (key, event) => {
    setJobAttrs({ ...jobAttrs, service: key })
  };

  const onRecurrenceSelect = (key, event) => {
    setJobAttrs({ ...jobAttrs, recurrence: key })
  };

  const onStateSelect = (key, event) => {
    setJobAttrs({ ...jobAttrs, stateSetting: key })
  };

  const onDatepickerChangeStartTime = (value) => {
    let newTime = (new Date(value)).getTime();
    let currentTime = (new Date()).getTime();

    // ### This check is not necessary, since the UI already built guardrail.  But keep it here for now. ###
    if (!value && (value != null) && (newTime < currentTime)) {
      setErrMsg(t("I18N_ERR_Date_must_be_future"));
    } else {
      setErrMsg(t(""));
      setJobAttrs({ ...jobAttrs, startTime: value })
    }
  }

  const onDatepickerChangeEndTime = (value) => {
    let newTime = (new Date(value)).getTime();
    let currentTime = (new Date()).getTime();

    // ### This check is not necessary, since the UI already built guardrail.  But keep it here for now. ###
    if (!value && (value != null) && (newTime < currentTime)) {
      setErrMsg(t("I18N_ERR_Date_must_be_future"));
    } else {
      setErrMsg(t(""));
      setJobAttrs({ ...jobAttrs, endTime: value })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!jobAttrs.name || jobAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_job_name"));
    } else if (jobAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("jobs?name=" + jobAttrs.name);

        resolve(res.data);

        if (res.data.length > 0) {
          setErrMsg(t("I18N_ERR_job_name_taken"));
        } else {
          validateOtherFields();
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {
    // Validate form inputs
    if (jobAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (jobAttrs.service === '') {
      setErrMsg(t("I18N_ERR_Need_service"));
    } else if (jobAttrs.stateSetting === '') {
      setErrMsg(t("I18N_ERR_Need_state"));
    } else if (jobAttrs.recurrence === '') {
      setErrMsg(t("I18N_ERR_Need_recurrence"));
    } else if ((jobAttrs.frequency !== null) && (jobAttrs.frequency !== '') &&
               ((!isNaturalNumber(jobAttrs.frequency)) || (jobAttrs.frequency > 2147483647))) {
      setErrMsg(t("I18N_Interval") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
    } else {
      setErrMsg('');
      createJob();
    }
  }

  const createJob = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(jobAttrs));

    reqBody.startTime  = (jobAttrs.startTime  ? jobAttrs.startTime.toISOString()  : "");
    reqBody.endTime    = (jobAttrs.endTime    ? jobAttrs.endTime.toISOString()    : "");

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("jobs", reqBody);

        resolve(res.data);

        if (res.status === 201) {
          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Job")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Job_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Job_name")}: *</Col>
              <Col>{t("I18N_Description")}:</Col>
              <Col>{t("I18N_Service")}: *</Col>
              <Col>{t("I18N_State_setting")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name"
                       value={jobAttrs.name} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="description"
                          value={jobAttrs.description} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!jobAttrs.service ? t("common:I18N_DROPDOWN_PROMPT") :
                          (serviceOptions.find( ({ key }) => key === jobAttrs.service )).value}
                  onSelect={onServiceSelect}>
                  {serviceOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!jobAttrs.stateSetting ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (stateOptions.find( ({ key }) => key === jobAttrs.stateSetting )).value)}
                  onSelect={onStateSelect}>
                  {stateOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col>{t("I18N_Recurrence")}: *</Col>
              <Col>{t("I18N_Interval_w_src")}:</Col>
              <Col>{t("I18N_Start_time")}: </Col>
              <Col>{t("I18N_End_time")}: </Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!jobAttrs.recurrence ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (recurrenceOptions.find( ({ key }) => key === jobAttrs.recurrence )).value)}
                  onSelect={onRecurrenceSelect}>
                  {recurrenceOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="frequency"
                       value={jobAttrs.frequency} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
{/*
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="startTime"
                       value={jobAttrs.startTime} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col>
                <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="endTime"
                       value={jobAttrs.endTime} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
*/}
              <Col>
                <DateTimePicker onChange={onDatepickerChangeStartTime} value={jobAttrs.startTime}
                   format={ (jobAttrs.startTime != null) ? "y-MM-dd h:00 a" : "y-MM-dd h:-- a" }
                   minDate={new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                   disableClock="true"
                   clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                   calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                   locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                />
              </Col>
              <Col>
                <DateTimePicker onChange={onDatepickerChangeEndTime} value={jobAttrs.endTime}
                   format={ (jobAttrs.endTime != null) ? "y-MM-dd h:00 a" : "y-MM-dd h:-- a" }
                   minDate={ jobAttrs.startTime ? jobAttrs.startTime : new Date(3600000 * ( Math.round(Date.now() / 3600000)))}
                   disableClock="true"
                   clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                   calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                   locale={i18n.language === 'zh_HK' ? "zh-HK" : (i18n.language === 'zh_CN' ? "zh-CN" : "en")}
                />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default JobAdmin_NewJobView;
